<template>
    <v-container
        class="pa-6 justify-center"
        style="height: 100%; width: 600px"
        v-if="selectedRecord && isApproval"
    >
        <div v-if="!loading">
            <v-card class="d-lg-flex ma-4 pa-2" width="100%">
                <RecordDetails
                    recordType="Approval"
                    :referenceString="selectedRecord.reference_table"
                />
            </v-card>
        </div>

        <div v-else class="text-xs-center" style="padding: 50px">
            <v-progress-circular indeterminate color="typography3" />
        </div>
    </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import RecordDetails from './RecordDetails.vue'

const store = useStore()
const route = useRoute()

const loading = ref(true)

const selectedRecord = computed(() => store.state.selectedRecord)
const isApproval = computed(() => store.dispatch('isApproval'))

onMounted(async () => {
    await store.dispatch('getRecord', route.params.recordId)
    await store.dispatch('getFlowId', selectedRecord.value.type.flow_id)
    loading.value = false
})
</script>

<style scoped>
#submit-btn {
    color: white;
    margin: 5px;
    align-content: center;
}
</style>
